import type {PublicMethodUtils} from '@wix/document-services-types'
import type {MiniSitePublicAPI} from '@wix/document-services-public-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<MiniSitePublicAPI> {
    const {
        extensionPublicAPI: {immediate}
    } = publicMethodUtils

    return {
        methods: {
            miniSite: {
                loadCSM: immediate('miniSite.loadCSM'),
                createPreviewElementsHTML: immediate('miniSite.createPreviewElementsHTML'),
                loadCSMForCurrentMSID: immediate('miniSite.loadCSMForCurrentMSID')
            }
        }
    }
}
